import { createI18n } from 'vue-i18n'
import mk from './locales/mk'
import en from './locales/en'
import sq from './locales/sq'

// Get saved language from localStorage or default to 'mk'
const savedLocale = localStorage.getItem('storefront-locale') || 'mk'

export const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'mk',
  messages: {
    mk,
    en,
    sq,
  },
})

export default i18n
